import { useState } from 'react';
import { FormControl, FormLabel, Stack, Box, Text } from '@chakra-ui/react';
import { Field } from 'formik';
import BooleanToggle from '@/components/forms/new/formikFormFields/BooleanToggle';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackStyling,
    stackSpacing,
    descriptionStyling,
} from '@/components/forms/new/formStyles';

const SelectiveSyncToggle = ({ darkMode, serviceWizard }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleSelectChange = (toggle) => {
        serviceWizard.setSelectiveSyncToggle(toggle);
    };

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(true), width: '740px' }}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Selective Sync
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enable selective synchronisation of users and data.
                    </Text>
                </Box>
                <Box flex={1} paddingTop="22px" maxWidth="400px">
                    <Field
                        component={BooleanToggle}
                        id="selectiveSyncToggle"
                        name="selectiveSyncToggle"
                        isChecked={serviceWizard.selectiveSyncToggle}
                        onChange={handleSelectChange}
                    />
                    {isHovered && (
                        <FieldToolTip
                            label="Enable selective sync"
                            ariaLabel="selective-sync-toggle-tip"
                            left="25px"
                            bottom="5px"
                        />
                    )}
                </Box>
            </Stack>
        </FormControl>
    );
};

export default SelectiveSyncToggle;
